import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { PageHeader } from '@sorare/core/src/components/navigation/PageHeader';
import { useQueryLoader } from '@sorare/core/src/hooks/graphql/useQueryLoader';
import { glossary } from '@sorare/core/src/lib/glossary';
import { queryLoader } from '@sorare/core/src/lib/navigation/queryLoader';
import { LegacyPacksPage as LegacyPacksPageComponent } from '@sorare/marketplace/src/components/commonCard/LegacyPacksPage';

import type {
  LegacyPacksQuery,
  LegacyPacksQueryVariables,
} from './__generated__/page.graphql.ts';
import type { PageParams } from './__generated__/routeParams.ts';

const LEGACY_PACKS_QUERY = gql`
  query LegacyPacksQuery($sport: Sport!) {
    market {
      id
      ...LegacyPacksPage_marketRoot
    }
    currentUser {
      slug
      anyUserSportProfile(sport: $sport) {
        id
        commonGameOnboarded
      }
    }
  }
  ${LegacyPacksPageComponent.fragments.marketRoot}
` as TypedDocumentNode<LegacyPacksQuery, LegacyPacksQueryVariables>;

export const loader = queryLoader<PageParams>(
  LEGACY_PACKS_QUERY,
  ({ sport }) => ({
    sport,
  })
);

const LegacyPacksPage = () => {
  const { data, refetch } = useQueryLoader<LegacyPacksQuery>();
  const marketRoot = data.market;

  return (
    <>
      <PageHeader text={glossary.legacyPacks} />
      <LegacyPacksPageComponent marketRoot={marketRoot} refetch={refetch} />
    </>
  );
};

export default LegacyPacksPage;
